<template>
  <EditableArea :content="main">
    <div class="image-slider relative" :class="{ 'is-edit-mode': isMagnoliaEdit }">
      <Swiper
        :modules="[Pagination, Navigation]"
        :navigation="{ prevEl: prevBtn, nextEl: nextBtn }"
        :pagination="{ clickable: true }"
        class="absolute rounded"
        :enabled="!isMagnoliaEdit"
      >
        <SwiperSlide v-for="childContent in mapNodes(main)" :key="childContent['id']">
          <EditableComponent :content="childContent">
            <PictureElement :breakpoints="imageBreakpoints" :img="childContent"> </PictureElement>
          </EditableComponent>
        </SwiperSlide>
        <div
          class="pointer-events-none absolute inset-4 isolate z-10 flex items-center justify-between"
          @mousedown.prevent
        >
          <div
            ref="prevBtn"
            class="swiper-navigation prev pointer-events-auto cursor-pointer rounded-full bg-white/50 p-2 hover:bg-action-07 hover:text-white"
          >
            <svg-icon class="h-4 w-4 -rotate-90" name="Arrow-Up"></svg-icon>
          </div>
          <div
            ref="nextBtn"
            class="swiper-navigation next pointer-events-auto cursor-pointer rounded-full bg-white/50 p-2 hover:bg-action-07 hover:text-white"
          >
            <svg-icon class="h-4 w-4 rotate-90" name="Arrow-Up"></svg-icon>
          </div>
        </div>
      </Swiper>
    </div>
  </EditableArea>
</template>

<script setup>
import { EditableArea, EditableComponent } from "@magnolia/vue-editor";
import { Navigation, Pagination } from "swiper/modules";
import { mapNodes } from "~/utils/helper/magnolia";
import "~/assets/css/thirdparty/swiper.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import PictureElement from "~/templates/elements/PictureElement.vue";
const prevBtn = ref(null);
const nextBtn = ref(null);

import { DIMENSIONS } from "~/utils/helper/imaging";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

const { isMagnoliaEdit } = useMagnoliaContext();
const imageBreakpoints = {
  start: DIMENSIONS["start"].ratio.video,
  sm: DIMENSIONS["sm"].ratio.video,
  md: DIMENSIONS["md"].ratio.video,
  xl: DIMENSIONS["xl"].ratio.video,
  container: DIMENSIONS["container"].ratio.video,
};

defineProps(["main"]);

defineOptions({
  inheritAttrs: false,
});
</script>
<style>
.image-slider {
  /**
    Disable slider in edit mode and make area scrollable
*/
  &.is-edit-mode .swiper-wrapper {
    @apply overflow-auto;

    transform: none !important;
  }
  .swiper-btn {
    @apply mx-6;
  }
  .swiper-navigation {
    @apply motion-safe:transition-opacity motion-safe:duration-700;
  }

  .swiper-navigation.swiper-button-disabled {
    @apply pointer-events-none opacity-0;
  }

  .swiper-pagination-bullets {
    --swiper-pagination-bottom: theme("spacing.4");
    --swiper-pagination-bullet-horizontal-gap: theme("spacing.3");
  }
}
</style>
